import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { UpdateWebAlertsStreamParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";

export const UpdateWebAlertsStream = graphql(/* GraphQL */ `
	mutation UpdateWebAlertsStream($params: UpdateWebAlertsStreamParams!) {
		updateWebAlertsStream(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useUpdateWebAlertsStream() {
	const [updateWebAlertsStream] = useMutation(UpdateWebAlertsStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleUpdateWebAlertsStream = useCallback(
		async (params: UpdateWebAlertsStreamParams) => {
			const result = await updateWebAlertsStream({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.updateWebAlertsStream.success,
				error: result.data?.updateWebAlertsStream.error,
			};
		},
		[updateWebAlertsStream]
	);

	return { handleUpdateWebAlertsStream };
}
